import { TrendingUp, Gauge, Clock, AlertCircle, PauseCircle, Timer } from 'lucide-react';

interface StatisticsFooterProps {
  totalDistance: number;
  maxSpeed: number;
  totalMinutes: number;
  idleMinutes: number;
  speedingMinutes: number;
}

function formatDuration(minutes: number): string {
  if (minutes < 60) return `${minutes}m`;
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  return mins > 0 ? `${hours}h ${mins}m` : `${hours}h`;
}

export function StatisticsFooter({
  totalDistance,
  maxSpeed,
  totalMinutes,
  idleMinutes,
  speedingMinutes
}: StatisticsFooterProps) {
  return (
    <div 
      className="fixed bottom-0 right-0 h-12 bg-background border-t z-20"
      style={{
        left: 'calc(var(--sidebar-width, 0px) + 420px)'
      }}
    >
      <div className="px-4 h-full flex items-center">
        <div className="grid grid-cols-6 gap-4 w-full">
          {/* Km Percorrido */}
          <div className="flex flex-col">
            <div className="flex items-center gap-1.5 mb-0.5">
              <TrendingUp className="h-3.5 w-3.5 text-muted-foreground" />
              <span className="text-[10px] text-muted-foreground uppercase font-medium">
                Km Percorrido
              </span>
            </div>
            <span className="text-xs font-bold text-foreground">
              {totalDistance.toFixed(1)} km
            </span>
          </div>

          {/* Vel. Máxima */}
          <div className="flex flex-col">
            <div className="flex items-center gap-1.5 mb-0.5">
              <Gauge className="h-3.5 w-3.5 text-muted-foreground" />
              <span className="text-[10px] text-muted-foreground uppercase font-medium">
                Vel. Máxima
              </span>
            </div>
            <span className="text-xs font-bold text-foreground">
              {maxSpeed} km/h
            </span>
          </div>

          {/* Tempo Ligado */}
          <div className="flex flex-col">
            <div className="flex items-center gap-1.5 mb-0.5">
              <Clock className="h-3.5 w-3.5 text-muted-foreground" />
              <span className="text-[10px] text-muted-foreground uppercase font-medium">
                Tempo Ligado
              </span>
            </div>
            <span className="text-xs font-bold text-foreground">
              {formatDuration(totalMinutes)}
            </span>
          </div>

          {/* Tempo Parado */}
          <div className="flex flex-col">
            <div className="flex items-center gap-1.5 mb-0.5">
              <PauseCircle className="h-3.5 w-3.5 text-orange-600" />
              <span className="text-[10px] text-muted-foreground uppercase font-medium">
                Tempo Parado
              </span>
            </div>
            <span className="text-xs font-bold text-orange-600">
              {formatDuration(idleMinutes)}
            </span>
          </div>

          {/* Altíssima */}
          <div className="flex flex-col">
            <div className="flex items-center gap-1.5 mb-0.5">
              <AlertCircle className="h-3.5 w-3.5 text-destructive" />
              <span className="text-[10px] text-muted-foreground uppercase font-medium">
                Altíssima
              </span>
            </div>
            <span className="text-xs font-bold text-destructive">
              {formatDuration(speedingMinutes)}
            </span>
          </div>

          {/* Parado+Ligado */}
          <div className="flex flex-col">
            <div className="flex items-center gap-1.5 mb-0.5">
              <Timer className="h-3.5 w-3.5 text-orange-600" />
              <span className="text-[10px] text-muted-foreground uppercase font-medium">
                Parado+Ligado
              </span>
            </div>
            <span className="text-xs font-bold text-orange-600">
              {formatDuration(idleMinutes)}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
